import {Component, OnDestroy, OnInit} from '@angular/core';
import {ArticlesService, StateService, AuthService} from '../shared/service';
import {ArticleModel} from '../shared/models/article.model';
import {ArticlesModel} from '../shared/models/articles.model';
import {Subscription} from 'rxjs';
import {HomeCarouselService} from '../shared/service/home-carousel.service';
import {HomeCarouselItemsModel} from '../shared/models/home-carousel-items.model';
import {HomeCarouselModel} from '../shared/models/home-carousel.model';
import {Router} from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  private isSidebarOpen: boolean;

  articles: ArticleModel[] = [];
  filteredArticles: ArticleModel[] = [];
  homeCarouselItems: HomeCarouselModel[] = [];
  highlightedArticle: ArticleModel;
  subscriptions: Subscription[] = [];

  constructor(private stateService: StateService,
              private userService: AuthService,
              private articlesService: ArticlesService,
              private homeCarouselService: HomeCarouselService,
              private router: Router) {

    this.stateService.sideMenuState.subscribe((state) => {
      this.isSidebarOpen = state;
    });

    this.subscriptions.push(this.articlesService.articles.subscribe((articles: ArticlesModel) => {
      if (articles && articles.items) {
        this.articles = articles.items;
        this.filteredArticles = articles.items.filter((item) => !item.highlighted).slice(0, 2);
       this.setHighlightedArticle();
      }
    }));


    this.subscriptions.push(this.homeCarouselService.homeCarouselItems.subscribe((carouselItems: HomeCarouselItemsModel) => {
      if (carouselItems && carouselItems.items) {
        this.homeCarouselItems = carouselItems.items;
      }
    }));

  }

  ngOnInit() {
  }

  setHighlightedArticle() {
    const highlightedArticles = this.articles.filter((item) => item.highlighted);
    if (highlightedArticles.length) {
      this.highlightedArticle = highlightedArticles[0];
      highlightedArticles.forEach((item) => {
        if (item.createdAt > this.highlightedArticle.createdAt) {
          this.highlightedArticle = item;
        }
      });
    }

  }

  getHighlightedArticleStyle() {
    return {
      'background': `url('${this.highlightedArticle.imageUrl}') center center no-repeat`,
      'background-size': 'cover'
    };
  }

  toggleSideBar() {
    this.stateService.setSelectedSideMenuState(!this.isSidebarOpen);
  }

  showLogoutModal() {
    this.userService.purgeAuth();
  }


  getArticleBg() {
    return {
      background: `url(${this.highlightedArticle.imageUrl})`,
    };
  }


  openArticle() {
    this.router.navigateByUrl('/article/' + this.highlightedArticle.id);
  }


  openArticlesPage() {
    this.router.navigateByUrl('/articles');
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

}

export interface HighlightedArticle {
  imageUrl: string;
  title: string;
  description: string;
  link: string
}


